import React, { useState } from 'react';
import { Dialog, DialogContent } from '../ui/dialog';
import { useApp } from '../../context/AppContext';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

export default function AuthModal() {
  const { state, actions } = useApp();
  const [currentView, setCurrentView] = useState('login'); // 'login' or 'register'

  const handleClose = () => {
    actions.setShowAuth(false);
    actions.setTryingToAddSpot(false);
  };

  const handleSuccess = () => {
    handleClose();
    
    // If user was trying to add a spot, open the add spot modal
    if (state.tryingToAddSpot) {
      actions.setShowAddSpot(true);
    }
  };

  const switchToRegister = () => setCurrentView('register');
  const switchToLogin = () => setCurrentView('login');

  return (
    <Dialog open={state.showAuth} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        {currentView === 'login' ? (
          <LoginForm
            onSuccess={handleSuccess}
            onSwitchToRegister={switchToRegister}
          />
        ) : (
          <RegisterForm
            onSuccess={handleSuccess}
            onSwitchToLogin={switchToLogin}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}